function getSearchURLParams(url)
{
    if(typeof url !== "string") {
        return {};
    }
   var urlSplit = url.split("?");
   if(urlSplit.length < 2) {
       return {};
   }
   return _.object(_.map(urlSplit[1].split("&"), function(params) {
       return params.split("=");
   }));
}
var jQuery = require("jQuery");
function getSuitelet(script, deploy) {
   return {"customscript_ns_sc_sl_contact_us_form:customdeploy_ns_sc_sl_contact_us_form":"/app/site/hosting/scriptlet.nl?script=925&deploy=1&compid=5216893&ns-at=AAEJ7tMQ7hMAQU_Aofz35lYxLDY2jTLUxJjKPRTUAn1rhcgvq3I"}[script + ":" + deploy];
}
var xhrFactory = jQuery.ajaxSettings.xhr;
jQuery.ajaxSettings.xhr = function() {
   var xhr = xhrFactory.apply(this, arguments);
   var open = xhr.open;
   xhr.open = function () {
        var url = arguments[1];
        var assocParams = getSearchURLParams(url);
        if(assocParams.hasOwnProperty("script") && assocParams.hasOwnProperty("deploy")) {
            var hashed = getSuitelet(assocParams["script"], assocParams["deploy"]);
            if(hashed) {
                var hashedParams = getSearchURLParams(hashed);
                var keys = Object.keys(assocParams);
                for (var i=0; i<keys.length; i++) {
                    var key = keys[i];
                    var value = assocParams[key];
                    if(!hashedParams.hasOwnProperty(key))
                    {
                        hashed += "&" + key + "=" + value;
                    }
                }
                arguments[1] = hashed;
            }
        }
        return open.apply(this, arguments);
    }
    return xhr;
}